var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 282.83380126953125 235.221923828125",
    filter: "drop-shadow(1.2px 1px 0.5px black)",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 336 235.2"
    },
    width: "282.83380126953125px",
    height: "235.221923828125px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 282.83380126953125,
    height: 235.221923828125,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    id: "ee-google-fonts"
  }, "@import url(https://fonts.googleapis.com/css?family=Audiowide:400);"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5883289575576782, 0, 0, 0.5883289575576782, -226.65897619470428, 2.4487362925045772)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -66.18340301513672, -582.4139404296875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 495.899994 604.599976 H 849.100006 V 945.599976 H 495.899994 V 604.599976 Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#173852",
    d: "M587.2,909c10.1,0,18.3,8.2,18.3,18.3c0,10.1-8.2,18.3-18.3,18.3c-10.1,0-18.3-8.2-18.3-18.3 C568.9,917.2,577.1,909,587.2,909L587.2,909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#173852",
    d: "M806.4,909c10.1,0,18.3,8.2,18.3,18.3c0,10.1-8.2,18.3-18.3,18.3c-10.1,0-18.3-8.2-18.3-18.3 C788.2,917.2,796.3,909,806.4,909L806.4,909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8CFE2",
    d: "M587.2,933.4L587.2,933.4c-3.5,0-6.6-2.5-7.3-6L575,903h24.4l-4.9,24.5 C593.8,930.9,590.8,933.4,587.2,933.4L587.2,933.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8CFE2",
    d: "M806.4,933.4L806.4,933.4c-3.5,0-6.6-2.5-7.3-6l-4.9-24.5h24.4l-4.9,24.5C813,930.9,810,933.4,806.4,933.4 L806.4,933.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C97F20",
    d: "M843.7,677.7l-297.5-36.4l-5.8-19.3c-2-6.5-7.3-11.3-13.9-12.6l-23.3-4.7c-3.3-0.7-6.5,1.5-7.2,4.8 c-0.7,3.3,1.5,6.5,4.8,7.2l23.3,4.7c2.2,0.4,4,2.1,4.6,4.2l58,191.5L555,876c-3.1,5.7-2.9,12.5,0.4,18c3.3,5.6,9.2,8.9,15.7,8.9 h253.6c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1H571.1c-3.1,0-4.7-2.1-5.2-3c-0.5-0.9-1.6-3.3-0.1-6l31.4-58.3l229-17.2 c9.5-0.7,16.9-8.7,16.9-18.2v-98.3c0,0,0,0,0,0c3,0,5.7-2.3,6-5.4C849.4,681.1,847,678.1,843.7,677.7z M643.3,732.5h-28.5 L599.2,660l35.5,4.3L643.3,732.5z M550.1,654l36.4,4.5l16,74h-28.5L550.1,654z M597.7,811.3l-20.2-66.6H605l14,65L597.7,811.3z M631.3,808.7l-13.8-64.1h27.4l7.9,62.5L631.3,808.7z M647.2,665.9l31.5,3.9l2.6,62.7h-25.7L647.2,665.9z M665,806.2l-7.8-61.6 h24.6l2.5,60.1L665,806.2z M718.1,802.2l-21.7,1.6l-2.5-59.2h24.1V802.2z M693.5,732.5l-2.5-61.2l27.2,3.3v57.9H693.5z M756.3,799.4l-26,2v-56.7h26V799.4z M730.3,732.5v-56.4l26,3.2v53.2H730.3z M794.2,796.5l-25.8,1.9v-53.8h25.8V796.5z M768.5,732.5v-51.7l25.8,3.2v48.5H768.5z M830.8,788.1c0,3.2-2.5,5.8-5.6,6.1l-18.7,1.4v-51h24.4V788.1z M806.4,732.5v-47.1 l24.4,3v44.1H806.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ce0320e9ccec31313b619bdace38ddb3.svg";
export { ForwardRef as ReactComponent };